import classes from './WorkflowList.module.css';

const WorkflowList = () => {
  return (
    <div>Workflow list copponent</div>
  )
}

export default WorkflowList;